<template>
  <div class="menu">
    <div class="confirm-wrapper">
      <sw-button label="confirmer"/>
      <sw-button label="annuler"/>
    </div>
    <div class="slider-wrapper">
      <input
        ref="range"
        type="range"
        v-model="currentValue"
        @input="onChange"
        :min="min"
        :max="max"
      >
      <div class="slider-tooltip" ref="tooltip">{{currentValue}}</div>
    </div>
  </div>
</template>
<script>
import ButtonMenu from '@/components/buttons/ButtonMenu'
import Slider from '@/components/slider/Slider'
import menu from '../menu-default'
import { mapGetters } from 'vuex'
export default {
  name: 'LuminositeMenu',
  mixins: [menu],
  components: {
    ButtonMenu,
    Slider
  },
  beforeCreate() {},
  async created() {
    this.dictionnary = await this.getLanguages
  },
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  data() {
    return {
      dictionnary: null,
      currentValue: 0,
      moving: false
    }
  },
  props: {
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    }
  },
  computed: {
    ...mapGetters(['getLanguages'])
  },
  methods: {
    onChange(evt) {
      const rangePercent = (this.currentValue / this.max) * 100
      const x = Math.floor((this.$refs.range.clientWidth * rangePercent) / 100)
      this.$refs.tooltip.style.left = `${x - this.$refs.tooltip.clientWidth}px`
    },
    out() {}
  },
  watch: {}
}
</script>
<style lang="stylus">
</style>




// WEBPACK FOOTER //
// src/components/menu/ajustement/LuminositeMenu.vue